/**
 * @file
 * Light / dark / system colour scheme switcher.
 *
 * The preference is applied to <html> as Web Awesome's own `wa-light` /
 * `wa-dark` class, so its components and our --eudat-* tokens flip together.
 * html.html.twig runs the same resolution inline before first paint; this file
 * only handles the switcher UI and live system-preference changes.
 */
export const STORAGE_KEY = 'eudat:theme';

const MODES = ['system', 'light', 'dark'];
const darkQuery = window.matchMedia('(prefers-color-scheme: dark)');

export function getPreference() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return MODES.includes(stored) ? stored : 'system';
}

export function applyPreference(pref) {
  const dark = pref === 'dark' || (pref === 'system' && darkQuery.matches);
  document.documentElement.classList.toggle('wa-dark', dark);
  document.documentElement.classList.toggle('wa-light', !dark);
}

Drupal.behaviors.eudatThemeSwitcher = {
  attach(context) {
    const switchers = context.querySelectorAll?.('[data-eudat-theme-switcher]') || [];
    if (!switchers.length) {
      return;
    }

    const syncAll = () => {
      const pref = getPreference();
      applyPreference(pref);
      document.querySelectorAll('[data-eudat-theme-switcher]').forEach((switcher) => {
        const icon = switcher.querySelector('[data-eudat-theme-icon]');
        const items = switcher.querySelectorAll('[data-eudat-theme]');
        items.forEach((item) => {
          const active = item.dataset.eudatTheme === pref;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-checked', active ? 'true' : 'false');
          if (active && icon) {
            icon.setAttribute('name', item.dataset.eudatThemeIcon);
          }
        });
      });
    };

    switchers.forEach((switcher) => {
      if (switcher.dataset.eudatThemeInit === '1') {
        return;
      }
      switcher.dataset.eudatThemeInit = '1';

      const items = switcher.querySelectorAll('[data-eudat-theme]');
      items.forEach((item) => {
        item.addEventListener('click', () => {
          localStorage.setItem(STORAGE_KEY, item.dataset.eudatTheme);
          syncAll();
        });
      });
    });

    // Only relevant while the preference is "system".
    if (!window._eudatDarkQueryBound) {
      window._eudatDarkQueryBound = true;
      darkQuery.addEventListener('change', syncAll);
    }

    syncAll();
  },
};
